export const ROLE_AFFILIATE = 2;

export const getDashboardPathForRole = (roleID, userId, agencyID = "0") => {
  if (roleID === ROLE_AFFILIATE) {
    return `/dashboard/register/${userId}`;
  }
  return `/dashboard/affiliatesAgency/detail/${agencyID}`;
};

export const isPathAllowedForRole = (uri, roleID, userId, agencyID = "0") => {
  if (roleID === ROLE_AFFILIATE) {
    return uri.includes(`/dashboard/register/${userId}`);
  }
  return uri.includes(`/dashboard/affiliatesAgency/detail/${agencyID}`);
};
